import {ProductList} from "../typescript-library";
import db64, {StoreDataType, StoreEntryType} from "./indexedDB";

export const getFromDatabase = async (urlSearchParams: URLSearchParams) => {
  const urlParams = new URLSearchParams(urlSearchParams);
  const queryLimit = Number(urlParams.get("limit") || "0") || ProductList.PRODUCT_LIST_DEFAULT_LIMIT;

  urlParams.delete("limit");
  urlParams.delete("offset");
  const urlSearchParamsString = urlParams.toString();

  return await db64.get(urlSearchParamsString, queryLimit);
};

export const setToDatabase = (data: StoreDataType, requestQuery: URLSearchParams): void => {
  // Shallow copy
  const urlSearchParams = new URLSearchParams(requestQuery);

  const offsetQuery = urlSearchParams.get("offset");
  const limitQuery = urlSearchParams.get("limit");

  if (!offsetQuery && !limitQuery) {
    // eslint-disable-next-line no-console
    console.log("setToDatabase, neither offsetQuery nor limitQuery set:", offsetQuery, ", limitQuery:", limitQuery);
  }

  const offset = Number(offsetQuery || "0");
  let limit: number;
  // Mind the fact, that the first offset shift will be ignored, bc of double load of content on page load,
  // and first non-zero offset will come from preload, seeming like two times pressed on "View more" button
  if (offset === 0) {
    limit = Number(limitQuery || "0");
  } else {
    limit = offset;
  }

  urlSearchParams.delete("limit");
  urlSearchParams.delete("offset");

  const dbObject: StoreEntryType = {
    query: urlSearchParams.toString(),
    limit,
    timestamp: Date.now(),
    ...data,
  };

  void db64.set(dbObject, limit);
};

/**
 * Swaps `preload` content to the end of the `current` content on the
 * database, after "View more" button, before fetch of new preload content.
 * Will also ignore `limit` and `query`
 * @param instance
 * @param queryParams
 */
export const swapToCurrent = async (instance: ProductList, queryParams: URLSearchParams) => {
  const uParams = new URLSearchParams(queryParams);
  uParams.delete("limit");
  uParams.delete("offset");

  await db64.swap(uParams.toString(), instance.offset);
};
